import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, ViewEncapsulation, Input, Output, ViewChild, HostListener, ViewChildren, NgModule } from '@angular/core';
import { Default, Required } from '@rogers/cdk/common/decorators';
import * as i2$1 from '@rogers/cdk/common/services';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@rogers/cdk/expander';
import { ExpanderModule } from '@rogers/cdk/expander';
import * as i5 from '@rogers/cdk/icon';
import { IconComponent } from '@rogers/cdk/icon';
import * as i6 from '@rogers/cdk/link';
import { LinkComponent } from '@rogers/cdk/link';
import * as i7 from '@rogers/cdk/button';
import { ButtonComponent } from '@rogers/cdk/button';
import * as i8 from '@rogers/cdk/badge';
import { BadgeComponent } from '@rogers/cdk/badge';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i1 from '@rogers/cdk/common/a11y';
import * as i2 from '@rogers/cdk/core';
import { BrandClassDirective } from '@rogers/cdk/common/directives';
const _c0 = ["categoryLink"];
const _c1 = (a0, a1) => ({
  "-active": a0,
  "-hasSubCopy": a1
});
const _c2 = (a0, a1, a2) => ({
  "ds-title-4": a0,
  "ds-body-r dsa-subnav__categoryLinkCopy": a1,
  "-selected": a2
});
function SubnavLinkComponent_ds_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ds-icon", 10);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r1.data.icon);
  }
}
function SubnavLinkComponent_ds_icon_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ds-icon", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r1.icon.name)("caption", ctx_r1.icon.caption);
  }
}
function SubnavLinkComponent_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 12);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r1.subCopy, i0.ɵɵsanitizeHtml);
  }
}
function SubnavLinkComponent_span_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.data.a11yDescription);
  }
}
function SubnavLinkComponent_ds_icon_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ds-icon", 14);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@indicatorRotate", ctx_r1.expanded);
  }
}
const _c3 = ["scrollArea"];
const _c4 = ["title"];
const _c5 = ["accountsRef"];
const _c6 = ["mainLevelItems"];
const _c7 = (a0, a1, a2) => ({
  category: a0,
  hasDropdown: a1,
  expanded: a2,
  isAccounts: true
});
const _c8 = (a0, a1) => [a0, a1];
const _c9 = a0 => ({
  "mr-16": a0
});
const _c10 = (a0, a1, a2) => ({
  category: a0,
  hasDropdown: a1,
  expanded: a2
});
const _c11 = (a0, a1, a2) => ({
  "bb-0": a0,
  "-column": a1,
  "-accounts": a2
});
const _c12 = a0 => ({
  row: a0
});
const _c13 = (a0, a1) => ({
  "ds-border-right": a0,
  "col-3 px-0": a1
});
function SubnavDesktopComponent_ul_5_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SubnavDesktopComponent_ul_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ul", 17)(1, "li", 18)(2, "dsa-subnav-link", 19, 3);
    i0.ɵɵlistener("expansionClick", function SubnavDesktopComponent_ul_5_Template_dsa_subnav_link_expansionClick_2_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.accountExpanded($event));
    })("ctaClick", function SubnavDesktopComponent_ul_5_Template_dsa_subnav_link_ctaClick_2_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.ctaClick.emit($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, SubnavDesktopComponent_ul_5_ng_container_4_Template, 1, 0, "ng-container", 20);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const subnav_r4 = i0.ɵɵreference(16);
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-menuitem", ctx_r2.data.categories.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("data", ctx_r2.data.accounts.link)("selected", ctx_r2.accountSelected || ctx_r2.data.accounts.link.selected)("isDropdown", ctx_r2.data.accounts.sections.length >= 0)("expanded", ctx_r2.isAccountExpanded)("tabIndex", 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", subnav_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction3(8, _c7, ctx_r2.data.accounts, (ctx_r2.data.accounts == null ? null : ctx_r2.data.accounts.sections.length) >= 0, ctx_r2.isAccountExpanded));
  }
}
function SubnavDesktopComponent_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function SubnavDesktopComponent_button_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.manualScroll("left"));
    });
    i0.ɵɵelement(1, "ds-icon", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("tabIndex", -1);
  }
}
function SubnavDesktopComponent_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 23);
  }
}
function SubnavDesktopComponent_li_12_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " >");
    i0.ɵɵelementContainerEnd();
  }
}
function SubnavDesktopComponent_li_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 24)(1, "dsa-subnav-link", 25, 4);
    i0.ɵɵlistener("expansionClick", function SubnavDesktopComponent_li_12_Template_dsa_subnav_link_expansionClick_1_listener($event) {
      const i_r7 = i0.ɵɵrestoreView(_r6).index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.controlExpanded(i_r7, $event));
    })("ctaClick", function SubnavDesktopComponent_li_12_Template_dsa_subnav_link_ctaClick_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.ctaClick.emit($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SubnavDesktopComponent_li_12_ng_container_3_Template, 2, 0, "ng-container", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const category_r8 = ctx.$implicit;
    const i_r7 = ctx.index;
    const isLast_r9 = ctx.last;
    const ctx_r2 = i0.ɵɵnextContext();
    const subnav_r4 = i0.ɵɵreference(16);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(10, _c8, "dsa-subnav__menuItem" + i_r7, ctx_r2.data.dropdownWidth === "column" ? "position-relativeXXX" : ""));
    i0.ɵɵattribute("data-menuitem", i_r7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("data", category_r8.link)("selected", ctx_r2.selectedMainLevel === i_r7 && !ctx_r2.accountSelected || category_r8.link.selected)("isDropdown", ctx_r2.hasDropdown[i_r7])("expanded", ctx_r2.expanded[i_r7])("tabIndex", 0)("ngClass", i0.ɵɵpureFunction1(13, _c9, !isLast_r9));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", subnav_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction3(15, _c10, category_r8, ctx_r2.hasDropdown[i_r7], ctx_r2.expanded[i_r7]));
  }
}
function SubnavDesktopComponent_div_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 26);
  }
}
function SubnavDesktopComponent_button_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵlistener("click", function SubnavDesktopComponent_button_14_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.manualScroll("right"));
    });
    i0.ɵɵelement(1, "ds-icon", 28);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("tabIndex", -1);
  }
}
function SubnavDesktopComponent_ng_template_15_ds_expander_0_li_3_p_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p", 38);
  }
  if (rf & 2) {
    const section_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r2.data.dropdownWidth === "column" ? "px-24" : "px-12")("innerHTML", section_r11.copy, i0.ɵɵsanitizeHtml);
  }
}
function SubnavDesktopComponent_ng_template_15_ds_expander_0_li_3_li_3_ds_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ds-icon", 44);
  }
  if (rf & 2) {
    const link_r13 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("name", link_r13.icon);
  }
}
function SubnavDesktopComponent_ng_template_15_ds_expander_0_li_3_li_3_span_4_ds_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ds-icon", 47);
  }
  if (rf & 2) {
    const link_r13 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("name", ctx_r2.getIconName(link_r13.badge.variant))("colour", (link_r13.badge == null ? null : link_r13.badge.variant) ? "feedback-" + (link_r13.badge == null ? null : link_r13.badge.variant) : "feedback-warning");
  }
}
function SubnavDesktopComponent_ng_template_15_ds_expander_0_li_3_li_3_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 45);
    i0.ɵɵtemplate(1, SubnavDesktopComponent_ng_template_15_ds_expander_0_li_3_li_3_span_4_ds_icon_1_Template, 1, 2, "ds-icon", 46);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r13 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("variant", link_r13.badge == null ? null : link_r13.badge.variant);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", link_r13.badge == null ? null : link_r13.badge.variant);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", link_r13.badge.copy, " ");
  }
}
function SubnavDesktopComponent_ng_template_15_ds_expander_0_li_3_li_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 39)(1, "a", 40);
    i0.ɵɵlistener("click", function SubnavDesktopComponent_ng_template_15_ds_expander_0_li_3_li_3_Template_a_click_1_listener() {
      const link_r13 = i0.ɵɵrestoreView(_r12).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.ctaClick.emit(link_r13));
    });
    i0.ɵɵtemplate(2, SubnavDesktopComponent_ng_template_15_ds_expander_0_li_3_li_3_ds_icon_2_Template, 1, 1, "ds-icon", 41);
    i0.ɵɵelement(3, "span", 42);
    i0.ɵɵtemplate(4, SubnavDesktopComponent_ng_template_15_ds_expander_0_li_3_li_3_span_4_Template, 3, 3, "span", 43);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const link_r13 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("selected", link_r13.selected)("a11yDescription", link_r13.a11yDescription)("ngClass", ctx_r2.data.dropdownWidth === "column" ? "px-24" : "px-12");
    i0.ɵɵattribute("href", link_r13.href, i0.ɵɵsanitizeUrl)("aria-label", ctx_r2.getAriaLabel(link_r13))("target", link_r13.target)("role", link_r13.role);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", link_r13.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", link_r13.copy, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", link_r13.badge == null ? null : link_r13.badge.copy);
  }
}
function SubnavDesktopComponent_ng_template_15_ds_expander_0_li_3_li_4_ds_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ds-icon", 44);
  }
  if (rf & 2) {
    const cta_r15 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("name", cta_r15.icon);
  }
}
function SubnavDesktopComponent_ng_template_15_ds_expander_0_li_3_li_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 39)(1, "a", 48);
    i0.ɵɵlistener("click", function SubnavDesktopComponent_ng_template_15_ds_expander_0_li_3_li_4_Template_a_click_1_listener() {
      const cta_r15 = i0.ɵɵrestoreView(_r14).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.ctaClick.emit(cta_r15));
    });
    i0.ɵɵtemplate(2, SubnavDesktopComponent_ng_template_15_ds_expander_0_li_3_li_4_ds_icon_2_Template, 1, 1, "ds-icon", 41);
    i0.ɵɵelement(3, "span", 42);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const cta_r15 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("selected", cta_r15.selected)("a11yDescription", cta_r15.a11yDescription)("ngClass", ctx_r2.data.dropdownWidth === "column" ? "px-24" : "px-12");
    i0.ɵɵattribute("href", cta_r15.href, i0.ɵɵsanitizeUrl)("aria-label", ctx_r2.getAriaLabel(cta_r15))("target", cta_r15.target)("role", cta_r15.role);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", cta_r15.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", cta_r15.copy, i0.ɵɵsanitizeHtml);
  }
}
function SubnavDesktopComponent_ng_template_15_ds_expander_0_li_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 34);
    i0.ɵɵtemplate(1, SubnavDesktopComponent_ng_template_15_ds_expander_0_li_3_p_1_Template, 1, 2, "p", 35);
    i0.ɵɵelementStart(2, "ul", 36);
    i0.ɵɵtemplate(3, SubnavDesktopComponent_ng_template_15_ds_expander_0_li_3_li_3_Template, 5, 10, "li", 37)(4, SubnavDesktopComponent_ng_template_15_ds_expander_0_li_3_li_4_Template, 4, 9, "li", 37);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const section_r11 = ctx.$implicit;
    const isLast_r16 = ctx.last;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c13, !isLast_r16 && !section_r11.hideDivider && ctx_r2.data.dropdownWidth !== "column", ctx_r2.data.dropdownWidth !== "column"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", section_r11.copy);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", section_r11.links);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", section_r11.ctas);
  }
}
function SubnavDesktopComponent_ng_template_15_ds_expander_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ds-expander", 30)(1, "div", 31)(2, "ul", 32);
    i0.ɵɵtemplate(3, SubnavDesktopComponent_ng_template_15_ds_expander_0_li_3_Template, 5, 7, "li", 33);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext();
    const category_r18 = ctx_r16.category;
    const expanded_r19 = ctx_r16.expanded;
    const isAccounts_r20 = ctx_r16.isAccounts;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("z-index", ctx_r2.data.zIndex || 1)("left", ctx_r2.data.dropdownWidth === "column" ? ctx_r2.leftColumnPosition + "px" : "0px");
    i0.ɵɵproperty("expanded", expanded_r19)("overflowHidden", false)("ngClass", i0.ɵɵpureFunction3(10, _c11, !expanded_r19, ctx_r2.data.dropdownWidth === "column", isAccounts_r20));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r2.data.dropdownWidth === "column" ? "py-16 px-0" : "py-32");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c12, ctx_r2.data.dropdownWidth !== "column"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", category_r18.sections);
  }
}
function SubnavDesktopComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SubnavDesktopComponent_ng_template_15_ds_expander_0_Template, 4, 16, "ds-expander", 29);
  }
  if (rf & 2) {
    const category_r18 = ctx.category;
    const hasDropdown_r21 = ctx.hasDropdown;
    i0.ɵɵproperty("ngIf", hasDropdown_r21 && category_r18);
  }
}
const _c14 = a0 => ({
  copy: a0
});
const _c15 = (a0, a1) => ({
  "bt-0": a0,
  "d-none": a1
});
function SubnavMobileComponent_li_4_div_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " >");
    i0.ɵɵelementContainerEnd();
  }
}
function SubnavMobileComponent_li_4_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, SubnavMobileComponent_li_4_div_2_ng_container_1_Template, 2, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    const subnav_r4 = i0.ɵɵreference(7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", subnav_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c10, ctx_r2.data.accounts, (ctx_r2.data.accounts == null ? null : ctx_r2.data.accounts.sections.length) >= 0, ctx_r2.isAccountExpanded));
  }
}
function SubnavMobileComponent_li_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 6)(1, "dsa-subnav-link", 7);
    i0.ɵɵlistener("expansionClick", function SubnavMobileComponent_li_4_Template_dsa_subnav_link_expansionClick_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.accountExpanded($event));
    })("ctaClick", function SubnavMobileComponent_li_4_Template_dsa_subnav_link_ctaClick_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.ctaClick.emit($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, SubnavMobileComponent_li_4_div_2_Template, 2, 6, "div", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-menuitem", 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("data", ctx_r2.data.accounts.link)("selected", ctx_r2.accountSelected || ctx_r2.data.accounts.link.selected)("isDropdown", ctx_r2.data.accounts.sections.length >= 0)("expanded", ctx_r2.isAccountExpanded);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.data.accounts);
  }
}
function SubnavMobileComponent_li_5_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " >");
    i0.ɵɵelementContainerEnd();
  }
}
function SubnavMobileComponent_li_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 6)(1, "dsa-subnav-link", 7);
    i0.ɵɵlistener("expansionClick", function SubnavMobileComponent_li_5_Template_dsa_subnav_link_expansionClick_1_listener($event) {
      const i_r6 = i0.ɵɵrestoreView(_r5).index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.controlExpanded(i_r6, $event));
    })("ctaClick", function SubnavMobileComponent_li_5_Template_dsa_subnav_link_ctaClick_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.ctaClick.emit($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, SubnavMobileComponent_li_5_ng_container_2_Template, 2, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const category_r7 = ctx.$implicit;
    const i_r6 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    const subnav_r4 = i0.ɵɵreference(7);
    i0.ɵɵattribute("data-menuitem", ctx_r2.data.accounts ? i_r6 + 1 : i_r6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("data", category_r7.link)("selected", ctx_r2.selectedMainLevel === i_r6 && !ctx_r2.accountSelected || category_r7.link.selected)("isDropdown", ctx_r2.hasDropdown[i_r6])("expanded", ctx_r2.expanded[i_r6]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", subnav_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction3(7, _c10, category_r7, ctx_r2.hasDropdown[i_r6], ctx_r2.expanded[i_r6]));
  }
}
function SubnavMobileComponent_ng_template_6_ds_expander_0_ng_container_2_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p", 18);
  }
  if (rf & 2) {
    const section_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", section_r8.copy, i0.ɵɵsanitizeHtml);
  }
}
function SubnavMobileComponent_ng_template_6_ds_expander_0_ng_container_2_li_3_ds_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ds-icon", 23);
  }
  if (rf & 2) {
    const link_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("name", link_r10.icon);
  }
}
function SubnavMobileComponent_ng_template_6_ds_expander_0_ng_container_2_li_3_span_4_ds_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ds-icon", 26);
  }
  if (rf & 2) {
    const link_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("name", ctx_r2.getIconName(link_r10.badge.variant))("colour", (link_r10.badge == null ? null : link_r10.badge.variant) ? "feedback-" + (link_r10.badge == null ? null : link_r10.badge.variant) : "feedback-warning");
  }
}
function SubnavMobileComponent_ng_template_6_ds_expander_0_ng_container_2_li_3_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 24);
    i0.ɵɵtemplate(1, SubnavMobileComponent_ng_template_6_ds_expander_0_ng_container_2_li_3_span_4_ds_icon_1_Template, 1, 2, "ds-icon", 25);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("variant", link_r10.badge == null ? null : link_r10.badge.variant);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", link_r10.badge == null ? null : link_r10.badge.variant);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", link_r10.badge.copy, " ");
  }
}
function SubnavMobileComponent_ng_template_6_ds_expander_0_ng_container_2_li_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 15)(1, "a", 19);
    i0.ɵɵlistener("click", function SubnavMobileComponent_ng_template_6_ds_expander_0_ng_container_2_li_3_Template_a_click_1_listener() {
      const link_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.ctaClick.emit(link_r10));
    });
    i0.ɵɵtemplate(2, SubnavMobileComponent_ng_template_6_ds_expander_0_ng_container_2_li_3_ds_icon_2_Template, 1, 1, "ds-icon", 20);
    i0.ɵɵelement(3, "span", 21);
    i0.ɵɵtemplate(4, SubnavMobileComponent_ng_template_6_ds_expander_0_ng_container_2_li_3_span_4_Template, 3, 3, "span", 22);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const link_r10 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("selected", link_r10.selected)("a11yDescription", link_r10.a11yDescription);
    i0.ɵɵattribute("href", link_r10.href, i0.ɵɵsanitizeUrl)("aria-label", ctx_r2.getAriaLabel(link_r10))("target", link_r10.target)("role", link_r10.role);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", link_r10.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", link_r10.copy, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", link_r10.badge == null ? null : link_r10.badge.copy);
  }
}
function SubnavMobileComponent_ng_template_6_ds_expander_0_ng_container_2_li_4_ds_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ds-icon", 23);
  }
  if (rf & 2) {
    const cta_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("name", cta_r12.icon);
  }
}
function SubnavMobileComponent_ng_template_6_ds_expander_0_ng_container_2_li_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 15)(1, "a", 27);
    i0.ɵɵlistener("click", function SubnavMobileComponent_ng_template_6_ds_expander_0_ng_container_2_li_4_Template_a_click_1_listener() {
      const cta_r12 = i0.ɵɵrestoreView(_r11).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.ctaClick.emit(cta_r12));
    });
    i0.ɵɵtemplate(2, SubnavMobileComponent_ng_template_6_ds_expander_0_ng_container_2_li_4_ds_icon_2_Template, 1, 1, "ds-icon", 20);
    i0.ɵɵelement(3, "span", 21);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const cta_r12 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("selected", cta_r12.selected)("a11yDescription", cta_r12.a11yDescription);
    i0.ɵɵattribute("href", cta_r12.href, i0.ɵɵsanitizeUrl)("aria-label", ctx_r2.getAriaLabel(cta_r12))("target", cta_r12.target)("role", cta_r12.role);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", cta_r12.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", cta_r12.copy, i0.ɵɵsanitizeHtml);
  }
}
function SubnavMobileComponent_ng_template_6_ds_expander_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li", 15);
    i0.ɵɵtemplate(2, SubnavMobileComponent_ng_template_6_ds_expander_0_ng_container_2_p_2_Template, 1, 1, "p", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SubnavMobileComponent_ng_template_6_ds_expander_0_ng_container_2_li_3_Template, 5, 9, "li", 17)(4, SubnavMobileComponent_ng_template_6_ds_expander_0_ng_container_2_li_4_Template, 4, 8, "li", 17);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const section_r8 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", section_r8.copy);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", section_r8.links);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", section_r8.ctas);
  }
}
function SubnavMobileComponent_ng_template_6_ds_expander_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ds-expander", 12)(1, "ul", 13);
    i0.ɵɵtemplate(2, SubnavMobileComponent_ng_template_6_ds_expander_0_ng_container_2_Template, 5, 3, "ng-container", 14);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    const category_r14 = ctx_r12.category;
    const expanded_r15 = ctx_r12.expanded;
    i0.ɵɵproperty("expanded", expanded_r15);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", category_r14.sections);
  }
}
function SubnavMobileComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SubnavMobileComponent_ng_template_6_ds_expander_0_Template, 3, 2, "ds-expander", 11);
  }
  if (rf & 2) {
    const hasDropdown_r16 = ctx.hasDropdown;
    i0.ɵɵproperty("ngIf", hasDropdown_r16);
  }
}
let SubnavService = /*#__PURE__*/(() => {
  class SubnavService {
    getBadgeIconName(variant) {
      if (variant === 'error') {
        return 'error-filled';
      } else if (variant === 'success') {
        return 'checkmark-filled';
      } else if (variant === 'info') {
        return 'info-filled';
      } else {
        return 'warning-filled';
      }
    }
    getAriaLabel(link) {
      const label = [];
      if (link.copy) label.push(link.copy);
      if (link.badge && link.badge.copy) label.push(link.badge.copy);
      if (link.alt) label.push(link.alt);
      if (link.a11yDescription) label.push(link.a11yDescription);
      return label.join(' ');
    }
    populateHasDropdown(data) {
      return data.categories.map(category => {
        return category.sections && category.sections.length && category.sections[0].links && category.sections[0].links.length ? true : false;
      });
    }
    populateExpandedCategories(categories) {
      const r = [];
      categories.forEach(c => {
        r.push(false);
      });
      return r;
    }
    getSelectedParentIndex(data) {
      let i = null;
      data.categories.forEach((category, catInx) => {
        if (category.sections && category.sections.length) {
          const hasSelected = category.sections.some(section => section.links.some(link => link.selected));
          if (hasSelected) {
            i = catInx;
          }
        }
      });
      return i;
    }
    isAccountSelected(subnavCategory) {
      let hasSelected = false;
      hasSelected = subnavCategory.sections.some(section => section.links.some(link => link.selected));
      return hasSelected;
    }
  }
  SubnavService.ɵfac = function SubnavService_Factory(t) {
    return new (t || SubnavService)();
  };
  SubnavService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SubnavService,
    factory: SubnavService.ɵfac,
    providedIn: 'root'
  });
  return SubnavService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SubnavLinkComponent = /*#__PURE__*/(() => {
  class SubnavLinkComponent {
    handleClick(e) {
      switch (e.key) {
        case ' ':
        case 'Enter':
          e.preventDefault();
          this.categoryLink.nativeElement.click();
          e.stopPropagation();
          break;
        default:
          break;
      }
    }
    get brand() {
      return this.cdkCore.brand;
    }
    constructor(element, focusMonitor, cdkCore, windowService) {
      this.element = element;
      this.focusMonitor = focusMonitor;
      this.cdkCore = cdkCore;
      this.windowService = windowService;
      this.ctaClick = new EventEmitter();
      this.expansionClick = new EventEmitter();
    }
    ngOnInit() {
      const label = [];
      if (this.data) {
        if (this.data.copy) label.push(this.data.copy);
        if (this.data.alt) label.push(this.data.alt);
        if (this.data.a11yDescription) label.push(this.data.a11yDescription);
      }
      this.ariaLabel = label.join(' ');
    }
    ngAfterViewInit() {
      this.focusMonitor.monitor(this.categoryLink, true);
    }
    ngOnDestroy() {
      this.focusMonitor.stopMonitoring(this.categoryLink);
    }
    isMobile() {
      return this.windowService.isMobile();
    }
    toggleExpansion() {
      if (this.isDropdown) {
        this.expanded = !this.expanded;
      } else {
        this.ctaClick.emit(this.data);
      }
      this.expansionClick.emit(this.expanded);
    }
    keyboardFocus() {
      this.focusMonitor.focusVia(this.categoryLink, 'keyboard');
    }
  }
  SubnavLinkComponent.ɵfac = function SubnavLinkComponent_Factory(t) {
    return new (t || SubnavLinkComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.FocusMonitor), i0.ɵɵdirectiveInject(i2.CDKCoreService), i0.ɵɵdirectiveInject(i2$1.WindowService));
  };
  SubnavLinkComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SubnavLinkComponent,
    selectors: [["dsa-subnav-link"]],
    viewQuery: function SubnavLinkComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.categoryLink = _t.first);
      }
    },
    hostVars: 4,
    hostBindings: function SubnavLinkComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("keydown", function SubnavLinkComponent_keydown_HostBindingHandler($event) {
          return ctx.handleClick($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵclassProp("d-block", true)("h-100", true);
      }
    },
    inputs: {
      expanded: "expanded",
      selected: "selected",
      isDropdown: "isDropdown",
      isLob: "isLob",
      data: "data",
      subCopy: "subCopy",
      icon: "icon",
      tabIndex: "tabIndex"
    },
    outputs: {
      ctaClick: "ctaClick",
      expansionClick: "expansionClick"
    },
    decls: 10,
    vars: 24,
    consts: [["categoryLink", ""], [1, "dsa-subnav__categoryLink", "w-100", "h-100", "align-items-center", "ds-txt-interactive-default-neutral", "d-flex", "outline-none", "ds-pointer", "text-no-decoration", 3, "click", "ngClass"], ["class", "mr-4", 3, "name", 4, "ngIf"], [1, "mb-0", "flex-grow-1", 3, "ngClass"], [3, "innerHTML"], [1, "d-flex"], [3, "name", "caption", 4, "ngIf"], ["class", "ds-body-r mb-0", 3, "innerHTML", 4, "ngIf"], ["class", "sr-only", 4, "ngIf"], ["class", "dsa-subnav__categoryLink__dropdownIcon", "name", "down", "colour", "interactive-default-neutral", 4, "ngIf"], [1, "mr-4", 3, "name"], [3, "name", "caption"], [1, "ds-body-r", "mb-0", 3, "innerHTML"], [1, "sr-only"], ["name", "down", "colour", "interactive-default-neutral", 1, "dsa-subnav__categoryLink__dropdownIcon"]],
    template: function SubnavLinkComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "a", 1, 0);
        i0.ɵɵlistener("click", function SubnavLinkComponent_Template_a_click_0_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.toggleExpansion());
        });
        i0.ɵɵtemplate(2, SubnavLinkComponent_ds_icon_2_Template, 1, 1, "ds-icon", 2);
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵelement(4, "span", 4);
        i0.ɵɵelementStart(5, "span", 5);
        i0.ɵɵtemplate(6, SubnavLinkComponent_ds_icon_6_Template, 1, 2, "ds-icon", 6)(7, SubnavLinkComponent_span_7_Template, 1, 1, "span", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, SubnavLinkComponent_span_8_Template, 2, 1, "span", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, SubnavLinkComponent_ds_icon_9_Template, 1, 1, "ds-icon", 9);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(17, _c1, ctx.isDropdown && ctx.expanded, ctx.subCopy));
        i0.ɵɵattribute("aria-expanded", ctx.isDropdown ? ctx.expanded : null)("aria-haspopup", !ctx.isMobile() && ctx.isDropdown ? true : null)("href", ctx.data.href, i0.ɵɵsanitizeUrl)("aria-label", ctx.ariaLabel)("target", ctx.data.target)("role", ctx.isMobile() && ctx.isDropdown ? "button" : ctx.data.role)("tabindex", ctx.tabIndex || 0)("aria-current", !ctx.isDropdown && ctx.selected ? "page" : null);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.data.icon);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(20, _c2, ctx.isLob, !ctx.isLob, ctx.selected));
        i0.ɵɵattribute("data-text", ctx.data.copy);
        i0.ɵɵadvance();
        i0.ɵɵproperty("innerHTML", ctx.data.copy, i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.icon);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.subCopy);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.data.a11yDescription);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.isDropdown);
      }
    },
    dependencies: [i3.NgClass, i3.NgIf, i5.IconComponent],
    encapsulation: 2,
    data: {
      animation: [trigger('indicatorRotate', [state('false, void', style({
        transform: 'rotate(0deg)'
      })), state('true', style({
        transform: 'rotate(180deg)'
      })), transition('true <=> false, void => false', animate('200ms ease-in-out'))])]
    }
  });
  __decorate([Default(false)], SubnavLinkComponent.prototype, "expanded", void 0);
  __decorate([Default(false)], SubnavLinkComponent.prototype, "selected", void 0);
  __decorate([Default(true)], SubnavLinkComponent.prototype, "isDropdown", void 0);
  __decorate([Default(false)], SubnavLinkComponent.prototype, "isLob", void 0);
  return SubnavLinkComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SubnavDesktopComponent = /*#__PURE__*/(() => {
  class SubnavDesktopComponent {
    handleKeyUpEvent(e) {
      const target = e.target;
      if (this.isMainLevelLink(target) && e.key === 'Tab') {
        this.closeAll();
        const i = +target.closest('.dsa-subnav__menuItem').getAttribute('data-menuitem');
        this.scrollMainLevelIntoView(this.mainLevelItems[i], i);
      }
    }
    handleEsc(e) {
      const target = e.target;
      let prevdef = true;
      if (e.key === 'Escape') {
        if (this.isMainLevelLink(target)) {
          this.closeAll();
        } else {
          this.goToIndex();
        }
      } else {
        prevdef = false;
      }
      if (prevdef) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
    onBlur(event) {
      if (!this.element.nativeElement.contains(event.relatedTarget)) {
        this.reset();
      }
    }
    clickout(event) {
      if (!this.element.nativeElement.contains(event.target)) {
        this.reset();
      }
    }
    get mainLevelItems() {
      return this._mainLevelItems.toArray();
    }
    constructor(element, subnavService, windowService) {
      this.element = element;
      this.subnavService = subnavService;
      this.windowService = windowService;
      this.currentMainLevel = 0;
      this.expanded = [];
      this.isScrollable = false;
      this.atLeftEnd = false;
      this.atRightEnd = false;
      this.ctaClick = new EventEmitter();
    }
    ngOnInit() {
      this.expanded = this.subnavService.populateExpandedCategories(this.data.categories);
      this.hasDropdown = this.subnavService.populateHasDropdown(this.data);
    }
    ngAfterContentInit() {
      setTimeout(() => {
        this.handleIndicators();
      }, 100);
    }
    ngOnChanges(changes) {
      if (typeof changes.data.previousValue === 'undefined' || changes.data.currentValue !== changes.data.previousValue) {
        this.expanded = this.subnavService.populateExpandedCategories(this.data.categories);
        this.hasDropdown = this.subnavService.populateHasDropdown(this.data);
        if (this.data.accounts) {
          this.accountSelected = this.subnavService.isAccountSelected(this.data.accounts);
        }
        this.selectedMainLevel = this.subnavService.getSelectedParentIndex(this.data);
      }
    }
    getAriaLabel(link) {
      return this.subnavService.getAriaLabel(link);
    }
    getIconName(variant) {
      return this.subnavService.getBadgeIconName(variant);
    }
    reset() {
      this.closeAll();
      this.currentMainLevel = 0;
    }
    closeAll() {
      this.expanded = this.expanded.map(e => false);
      this.isAccountExpanded = false;
    }
    accountExpanded(isExpanded) {
      this.closeAll();
      this.isAccountExpanded = isExpanded;
      if (this.data && this.data.dropdownWidth === 'column') {
        this.leftColumnPosition = this.title.nativeElement.offsetLeft + this.title.nativeElement.getBoundingClientRect().width + 16;
      }
    }
    controlExpanded(catIndex, isExpanded) {
      this.currentMainLevel = catIndex;
      this.closeAll();
      this.expanded[catIndex] = isExpanded;
      if (this.data && this.data.dropdownWidth === 'column') {
        this.setLeftPositionForColumn(catIndex);
      }
    }
    manualScroll(direction) {
      const left = this.scrollArea.nativeElement.offsetWidth / 2;
      const scrollLeft = this.scrollArea.nativeElement.scrollLeft;
      this.scrollArea.nativeElement.scrollTo({
        left: direction === 'left' ? scrollLeft - left : scrollLeft + left,
        behavior: 'smooth'
      });
    }
    /*
      Due to overflow auto, scroll position must be handled by JS
    */
    setLeftPositionForColumn(i) {
      // for all but last expander trigger must account for right margin
      const adj = this.hasDropdown.length - 1 === i && this.hasDropdown[i] ? 0 : 16;
      const menuItem = this.element.nativeElement.querySelector('.dsa-subnav__menuItem' + i);
      const menuItemRect = menuItem.getBoundingClientRect();
      const subnavRect = this.element.nativeElement.getBoundingClientRect();
      // 270 - width of column
      const posLeft = menuItemRect.x + menuItemRect.width - 270 - adj - subnavRect.x;
      this.leftColumnPosition = posLeft < 0 ? 0 : posLeft;
    }
    handleIndicators() {
      if (this.windowService.isBrowser()) {
        const scrollArea = this.scrollArea.nativeElement;
        const scrollLeft = scrollArea.scrollLeft;
        const offsetWidth = scrollArea.offsetWidth;
        const scrollWidth = scrollArea.scrollWidth;
        this.isScrollable = scrollWidth - 1 > offsetWidth ? true : false;
        this.atLeftEnd = scrollLeft <= 0 ? true : false;
        this.atRightEnd = scrollWidth - Math.round(scrollLeft) === offsetWidth || scrollWidth + 1 - Math.round(scrollLeft) === offsetWidth || scrollWidth - 1 - Math.round(scrollLeft) === offsetWidth ? true : false;
      }
    }
    onScroll(e) {
      this.handleIndicators();
      this.closeAll();
    }
    isMainLevelLink(el) {
      return el.classList.contains('dsa-subnav__categoryLink');
    }
    // navigation to main level link elements
    goToIndex() {
      this.isAccountExpanded ? this.accountsRef.keyboardFocus() : this.mainLevelItems[this.currentMainLevel].keyboardFocus();
      this.closeAll();
    }
    scrollMainLevelIntoView(el, currentMainLevel) {
      if (this.windowService.isBrowser()) {
        const scrollArea = this.scrollArea.nativeElement;
        const mainLevelLink = el.element.nativeElement;
        const x = scrollArea.clientWidth;
        const y = mainLevelLink.offsetWidth;
        const z = currentMainLevel;
        let q = 0;
        const m = scrollArea.querySelectorAll('.dsa-subnav__menuItem');
        for (let i = 0; i < z; i++) {
          q += m[i].offsetWidth;
        }
        scrollArea.scrollLeft = Math.max(0, q - (x - y) / 2);
      }
    }
  }
  SubnavDesktopComponent.ɵfac = function SubnavDesktopComponent_Factory(t) {
    return new (t || SubnavDesktopComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(SubnavService), i0.ɵɵdirectiveInject(i2$1.WindowService));
  };
  SubnavDesktopComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SubnavDesktopComponent,
    selectors: [["dsa-subnav-desktop"]],
    viewQuery: function SubnavDesktopComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c3, 7);
        i0.ɵɵviewQuery(_c4, 7);
        i0.ɵɵviewQuery(_c5, 5);
        i0.ɵɵviewQuery(_c6, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scrollArea = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.title = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.accountsRef = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._mainLevelItems = _t);
      }
    },
    hostVars: 4,
    hostBindings: function SubnavDesktopComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("keydown", function SubnavDesktopComponent_keydown_HostBindingHandler($event) {
          return ctx.handleEsc($event);
        })("focusout", function SubnavDesktopComponent_focusout_HostBindingHandler($event) {
          return ctx.onBlur($event);
        })("click", function SubnavDesktopComponent_click_HostBindingHandler($event) {
          return ctx.clickout($event);
        }, false, i0.ɵɵresolveDocument);
      }
      if (rf & 2) {
        i0.ɵɵclassProp("d-none", true)("d-md-block", true);
      }
    },
    inputs: {
      data: "data"
    },
    outputs: {
      ctaClick: "ctaClick"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 17,
    vars: 7,
    consts: [["title", ""], ["scrollArea", ""], ["subnav", ""], ["accountsRef", ""], ["mainLevelItems", ""], [1, "container", "d-flex", "justify-content-between", "align-items-stretch"], [1, "d-flex", "flex-shrink-0", "align-items-center"], [1, "ds-title-4", "mb-0", "py-16"], ["class", "list-none d-flex h-100", "role", "menubar", 4, "ngIf"], [1, "d-flex", "ds-no-overflow", "ml-16", "pl-48"], ["ds-button", "", "variant", "icon", "aria-hidden", "true", "class", "-prev flex-shrink-0 align-self-center", 3, "tabIndex", "click", 4, "ngIf"], ["class", "dsa-subnav__scrollIndicator -left", 4, "ngIf"], ["tabindex", "-1", 1, "dsa-subnav__scroll", "d-flex", 3, "scroll", "keyup"], ["role", "menubar", 1, "list-none", "d-flex"], ["class", "mb-0 dsa-subnav__menuItem flex-shrink-0", "role", "menuitem", 3, "ngClass", 4, "ngFor", "ngForOf"], ["class", "dsa-subnav__scrollIndicator -right", 4, "ngIf"], ["ds-button", "", "variant", "icon", "aria-hidden", "true", "class", "-next flex-shrink-0 align-self-center", 3, "tabIndex", "click", 4, "ngIf"], ["role", "menubar", 1, "list-none", "d-flex", "h-100"], ["role", "menuitem"], [1, "dsa-subnav__accountsLink", "ml-16", 3, "expansionClick", "ctaClick", "data", "selected", "isDropdown", "expanded", "tabIndex"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["ds-button", "", "variant", "icon", "aria-hidden", "true", 1, "-prev", "flex-shrink-0", "align-self-center", 3, "click", "tabIndex"], ["name", "chevron-left-outlined"], [1, "dsa-subnav__scrollIndicator", "-left"], ["role", "menuitem", 1, "mb-0", "dsa-subnav__menuItem", "flex-shrink-0", 3, "ngClass"], [3, "expansionClick", "ctaClick", "data", "selected", "isDropdown", "expanded", "tabIndex", "ngClass"], [1, "dsa-subnav__scrollIndicator", "-right"], ["ds-button", "", "variant", "icon", "aria-hidden", "true", 1, "-next", "flex-shrink-0", "align-self-center", 3, "click", "tabIndex"], ["name", "chevron-right-outlined"], ["class", "dsa-subnav__expander bt-0 position-absolute right-0 ds-bg-body-default ds-borders", 3, "expanded", "overflowHidden", "ngClass", "zIndex", "left", 4, "ngIf"], [1, "dsa-subnav__expander", "bt-0", "position-absolute", "right-0", "ds-bg-body-default", "ds-borders", 3, "expanded", "overflowHidden", "ngClass"], [1, "container", 3, "ngClass"], ["role", "menu", 1, "list-none", "mt-0", 3, "ngClass"], ["class", "mb-0", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "mb-0", 3, "ngClass"], ["class", "ds-body-r", 3, "ngClass", "innerHTML", 4, "ngIf"], [1, "list-none", "mt-0"], ["class", "mb-0", "role", "menuitem", 4, "ngFor", "ngForOf"], [1, "ds-body-r", 3, "ngClass", "innerHTML"], ["role", "menuitem", 1, "mb-0"], ["ds-link", "", "variant", "icon", 1, "w-100", "ds-no-overflow", "align-items-center", 3, "click", "selected", "a11yDescription", "ngClass"], ["class", "mr-4", 3, "name", 4, "ngIf"], [1, "ds-link__menuCopy", 3, "innerHTML"], ["ds-badge", "", "class", "ml-8", 3, "variant", 4, "ngIf"], [1, "mr-4", 3, "name"], ["ds-badge", "", 1, "ml-8", 3, "variant"], [3, "name", "colour", 4, "ngIf"], [3, "name", "colour"], ["ds-link", "", "variant", "cta", 1, "w-100", "ds-no-overflow", "align-items-center", 3, "click", "selected", "a11yDescription", "ngClass"]],
    template: function SubnavDesktopComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "p", 7, 0);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, SubnavDesktopComponent_ul_5_Template, 5, 12, "ul", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 9);
        i0.ɵɵtemplate(7, SubnavDesktopComponent_button_7_Template, 2, 1, "button", 10)(8, SubnavDesktopComponent_div_8_Template, 1, 0, "div", 11);
        i0.ɵɵelementStart(9, "div", 12, 1);
        i0.ɵɵlistener("scroll", function SubnavDesktopComponent_Template_div_scroll_9_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onScroll($event));
        })("keyup", function SubnavDesktopComponent_Template_div_keyup_9_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.handleKeyUpEvent($event));
        });
        i0.ɵɵelementStart(11, "ul", 13);
        i0.ɵɵtemplate(12, SubnavDesktopComponent_li_12_Template, 4, 19, "li", 14);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(13, SubnavDesktopComponent_div_13_Template, 1, 0, "div", 15)(14, SubnavDesktopComponent_button_14_Template, 2, 1, "button", 16);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(15, SubnavDesktopComponent_ng_template_15_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.data.lob, " ");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.data.accounts == null ? null : ctx.data.accounts.link);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.atLeftEnd && ctx.isScrollable);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.atLeftEnd && ctx.isScrollable);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngForOf", ctx.data.categories);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.atRightEnd && ctx.isScrollable);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.atRightEnd && ctx.isScrollable);
      }
    },
    dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, i4.ExpansionAreaComponent, i5.IconComponent, i6.LinkComponent, i7.ButtonComponent, i8.BadgeComponent, SubnavLinkComponent],
    encapsulation: 2
  });
  __decorate([Required()], SubnavDesktopComponent.prototype, "data", void 0);
  return SubnavDesktopComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SubnavMobileComponent = /*#__PURE__*/(() => {
  class SubnavMobileComponent {
    onBlur(event) {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        this.closeAll();
      }
    }
    constructor(subnavService, windowService) {
      this.subnavService = subnavService;
      this.windowService = windowService;
      this.expanded = [];
      this.mainExpanded = false;
      this.ctaClick = new EventEmitter();
      this.isIphone = this.windowService.isAppleMobileDevice();
    }
    ngOnInit() {
      this.expanded = this.subnavService.populateExpandedCategories(this.data.categories);
      this.hasDropdown = this.subnavService.populateHasDropdown(this.data);
    }
    ngOnChanges(changes) {
      if (typeof changes.data.previousValue === 'undefined' || changes.data.currentValue !== changes.data.previousValue) {
        this.expanded = this.subnavService.populateExpandedCategories(this.data.categories);
        this.hasDropdown = this.subnavService.populateHasDropdown(this.data);
        if (this.data.accounts) {
          this.accountSelected = this.subnavService.isAccountSelected(this.data.accounts);
        }
        this.selectedMainLevel = this.subnavService.getSelectedParentIndex(this.data);
      }
    }
    getAriaLabel(link) {
      return this.subnavService.getAriaLabel(link);
    }
    getIconName(variant) {
      return this.subnavService.getBadgeIconName(variant);
    }
    closeAll() {
      this.expanded = this.expanded.map(e => false);
      this.mainExpanded = false;
      this.isAccountExpanded = false;
    }
    accountExpanded(isExpanded) {
      this.isAccountExpanded = isExpanded;
    }
    controlExpanded(catIndex, isExpanded) {
      this.expanded[catIndex] = isExpanded;
    }
    controlMainExpanded(isExpanded) {
      this.mainExpanded = isExpanded;
    }
  }
  SubnavMobileComponent.ɵfac = function SubnavMobileComponent_Factory(t) {
    return new (t || SubnavMobileComponent)(i0.ɵɵdirectiveInject(SubnavService), i0.ɵɵdirectiveInject(i2$1.WindowService));
  };
  SubnavMobileComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SubnavMobileComponent,
    selectors: [["dsa-subnav-mobile"]],
    hostVars: 4,
    hostBindings: function SubnavMobileComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("focusout", function SubnavMobileComponent_focusout_HostBindingHandler($event) {
          return ctx.onBlur($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵclassProp("d-block", true)("d-md-none", true);
      }
    },
    inputs: {
      data: "data"
    },
    outputs: {
      ctaClick: "ctaClick"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 8,
    vars: 16,
    consts: [["subnav", ""], [3, "expansionClick", "data", "subCopy", "icon", "isLob", "expanded"], [1, "position-absolute", "left-0", "right-0", "w-100", "ds-bg-body-default", "ds-borders", 3, "expanded", "ngClass"], [1, "list-none"], ["class", "mb-0 dsa-subnav__menuItem", 4, "ngIf"], ["class", "mb-0 dsa-subnav__menuItem", 4, "ngFor", "ngForOf"], [1, "mb-0", "dsa-subnav__menuItem"], [3, "expansionClick", "ctaClick", "data", "selected", "isDropdown", "expanded"], ["class", "t-0", 4, "ngIf"], [1, "t-0"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "expanded", 4, "ngIf"], [3, "expanded"], [1, "list-none", "mt-0"], [4, "ngFor", "ngForOf"], [1, "mb-0"], ["class", "ds-body-r pl-48 pr-24", 3, "innerHTML", 4, "ngIf"], ["class", "mb-0", 4, "ngFor", "ngForOf"], [1, "ds-body-r", "pl-48", "pr-24", 3, "innerHTML"], ["ds-link", "", "variant", "icon", 1, "dsa-subnav__link", "w-100", "pl-48", "pr-24", 3, "click", "selected", "a11yDescription"], ["class", "mr-4", 3, "name", 4, "ngIf"], [1, "ds-link__menuCopy", 3, "innerHTML"], ["ds-badge", "", "class", "ml-8", 3, "variant", 4, "ngIf"], [1, "mr-4", 3, "name"], ["ds-badge", "", 1, "ml-8", 3, "variant"], [3, "name", "colour", 4, "ngIf"], [3, "name", "colour"], ["ds-link", "", "variant", "cta", 1, "dsa-subnav__link", "w-100", "pl-48", "pr-24", 3, "click", "selected", "a11yDescription"]],
    template: function SubnavMobileComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div")(1, "dsa-subnav-link", 1);
        i0.ɵɵlistener("expansionClick", function SubnavMobileComponent_Template_dsa_subnav_link_expansionClick_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.controlMainExpanded($event));
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "ds-expander", 2)(3, "ul", 3);
        i0.ɵɵtemplate(4, SubnavMobileComponent_li_4_Template, 3, 6, "li", 4)(5, SubnavMobileComponent_li_5_Template, 3, 11, "li", 5);
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(6, SubnavMobileComponent_ng_template_6_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("data", i0.ɵɵpureFunction1(11, _c14, ctx.data.lob))("subCopy", ctx.data.copy)("icon", ctx.data.icon)("isLob", true)("expanded", ctx.mainExpanded);
        i0.ɵɵadvance();
        i0.ɵɵstyleProp("z-index", ctx.data.zIndex || 1);
        i0.ɵɵproperty("expanded", ctx.mainExpanded)("ngClass", i0.ɵɵpureFunction2(13, _c15, !ctx.mainExpanded, !ctx.mainExpanded && ctx.isIphone));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.data.accounts == null ? null : ctx.data.accounts.link);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.data.categories);
      }
    },
    dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, i4.ExpansionAreaComponent, i5.IconComponent, i6.LinkComponent, i8.BadgeComponent, SubnavLinkComponent],
    encapsulation: 2
  });
  __decorate([Required()], SubnavMobileComponent.prototype, "data", void 0);
  return SubnavMobileComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SubnavComponent = /*#__PURE__*/(() => {
  class SubnavComponent {
    constructor() {
      this.ctaClick = new EventEmitter();
    }
    closeAll() {
      this.subnavDesktopComponent.closeAll();
      this.subnavMobileComponent.closeAll();
    }
  }
  SubnavComponent.ɵfac = function SubnavComponent_Factory(t) {
    return new (t || SubnavComponent)();
  };
  SubnavComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SubnavComponent,
    selectors: [["dsa-subnav"]],
    viewQuery: function SubnavComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(SubnavDesktopComponent, 7);
        i0.ɵɵviewQuery(SubnavMobileComponent, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.subnavDesktopComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.subnavMobileComponent = _t.first);
      }
    },
    inputs: {
      data: "data"
    },
    outputs: {
      ctaClick: "ctaClick"
    },
    decls: 3,
    vars: 3,
    consts: [["role", "navigation", 1, "dsa-subnav", "ds-bg-body-default", "ds-borders"], [3, "ctaClick", "data"]],
    template: function SubnavComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "nav", 0)(1, "dsa-subnav-mobile", 1);
        i0.ɵɵlistener("ctaClick", function SubnavComponent_Template_dsa_subnav_mobile_ctaClick_1_listener($event) {
          return ctx.ctaClick.emit($event);
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "dsa-subnav-desktop", 1);
        i0.ɵɵlistener("ctaClick", function SubnavComponent_Template_dsa_subnav_desktop_ctaClick_2_listener($event) {
          return ctx.ctaClick.emit($event);
        });
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵattribute("aria-label", ctx.data.a11yLabel);
        i0.ɵɵadvance();
        i0.ɵɵproperty("data", ctx.data);
        i0.ɵɵadvance();
        i0.ɵɵproperty("data", ctx.data);
      }
    },
    dependencies: [SubnavMobileComponent, SubnavDesktopComponent],
    encapsulation: 2
  });
  __decorate([Required()], SubnavComponent.prototype, "data", void 0);
  return SubnavComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SubnavModule = /*#__PURE__*/(() => {
  class SubnavModule {}
  SubnavModule.ɵfac = function SubnavModule_Factory(t) {
    return new (t || SubnavModule)();
  };
  SubnavModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: SubnavModule
  });
  SubnavModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, ExpanderModule, IconComponent, LinkComponent, ButtonComponent, BadgeComponent]
  });
  return SubnavModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { SubnavComponent, SubnavDesktopComponent, SubnavLinkComponent, SubnavMobileComponent, SubnavModule, SubnavService };
